import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import i18n from '../services/i18n';

// Создаем контекст с начальным значением
const LanguageContext = createContext({
  changeLanguage: () => {},
  currentLanguage: localStorage.getItem('appLanguage') || 'en'
});

export const LanguageProvider = ({ children }) => {
  const { user } = useAuth();
  // Начальный язык из localStorage
  const initialLang = localStorage.getItem('appLanguage') || 'en';
  const [currentLanguage, setCurrentLanguage] = useState(initialLang);
  
  // Логгируем текущее состояние
  useEffect(() => {
    console.log('LanguageProvider: текущий язык:', currentLanguage);
    console.log('LanguageProvider: пользователь:', user?.username);
  }, [currentLanguage, user]);
  
  // При изменении пользователя обновляем язык из его настроек
  useEffect(() => {
    if (user && user.settings && user.settings.language) {
      const userLanguage = user.settings.language;
      console.log('LanguageProvider: язык из настроек пользователя:', userLanguage);
      
      // Меняем язык только если он отличается от текущего
      if (userLanguage !== currentLanguage) {
        console.log('LanguageProvider: обновляем язык на', userLanguage);
        i18n.changeLanguage(userLanguage);
        setCurrentLanguage(userLanguage);
      }
    }
  }, [user, currentLanguage]);

  // Функция для изменения языка
  const changeLanguage = (lang) => {
    console.log('LanguageProvider: запрос на изменение языка:', lang);
    console.log('LanguageProvider: текущий язык:', currentLanguage);
    
    if (lang !== currentLanguage) {
      console.log('LanguageProvider: выполняем смену языка на:', lang);
      i18n.changeLanguage(lang);
      localStorage.setItem('appLanguage', lang); // Убедимся, что язык сохраняется в localStorage
      setCurrentLanguage(lang);
      console.log('LanguageProvider: язык изменен, уведомляем компоненты');
    } else {
      console.log('LanguageProvider: язык не изменился, пропускаем');
    }
  };

  return (
    <LanguageContext.Provider value={{ changeLanguage, currentLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook для использования контекста языка
export const useLanguage = () => useContext(LanguageContext);

export default LanguageContext; 